import React, { Component } from 'react'
import { TABLA_REPORTE_EMBARQUE_SECTOR_12_LINEA_5 } from '../../../../../../config/tables'
import MuiTable from '../../../../../Forms/SharedComponents/containers/MuiTable'
import { Container, Row, Col } from 'react-bootstrap'

export class ReporteEmbarqueSector12Linea5View extends Component {
  render () {
    return (
      <Container fluid>
        <Row>
          <Col md={12}>
            <h2>Sector 1-2 Linea 5</h2>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <MuiTable id={TABLA_REPORTE_EMBARQUE_SECTOR_12_LINEA_5} />
          </Col>
        </Row>
      </Container>
    )
  }
}
